import { FC } from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

interface props {
  items: any[]
  refine: any
  // Whether a Configure-based toggle (Clearance / Special Offers) is active.
  // These are invisible to connectCurrentRefinements, so we track them here to
  // keep the button enabled and clear them alongside the standard refinements.
  extraActive?: boolean
  onClearExtra?: () => void
}

const ClearAll: FC<props> = ({
  items,
  refine,
  extraActive = false,
  onClearExtra,
}) => {
  const disabled = items.length === 0 && !extraActive
  return (
    <button
      type="button"
      className="ais-ClearRefinements-button"
      disabled={disabled}
      onClick={() => {
        refine(items)
        onClearExtra?.()
      }}
    >
      Clear all filters
    </button>
  )
}

const ClearAllFilters = connectCurrentRefinements(ClearAll)
export default ClearAllFilters
